import ReactOnRails from 'react-on-rails/client';
import StaticPagesAbout from '../../app/StaticPagesAbout.js';

ReactOnRails.register({StaticPagesAbout});